import { TFunction } from 'i18next';

export const capFirst = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const capFirstLowerRest = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

export const isEmptyOrNull = (value: any): boolean => {
  return value === null || value === undefined || value === '';
};

export const appendOptional = (
  label: string,
  t: TFunction,
  append: boolean = true
): string => {
  if (append) {
    return `${label} (${t('common:optional')})`;
  } else {
    return label;
  }
};

export const getFullName = (firstname = '', lastname = '') =>
  [firstname?.trim(), lastname?.trim()].filter(Boolean).join(' ');

export const isNumeric = (str: string): boolean => {
  const numericRegex = /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/;
  return numericRegex.test(str);
};
